import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthDataDispatcher } from '../auth-data/auth-data.dispatcher';
import { BrowserManagerDataService } from './browser-manager-data.service';

@Injectable()
export class MobileGuard implements CanActivate {
  constructor(
    private _browserManagerDataService: BrowserManagerDataService,
    private _authDataDispatcher: AuthDataDispatcher
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const isMobile: boolean = this._browserManagerDataService.isMobile();

    if (isMobile) {
      this._authDataDispatcher.logout();
    }

    return !isMobile;
  }
}
